<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Everything you need to deliver Live Updates securely and at scale'
    "
    [icon]="'@tui.sparkles'"
    [subtitle]="'Key Features'"
    [title]="'Powerful features to keep your app up-to-date'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <!-- Code Signing -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.lock" class="mr-2" />
        <h3 class="text-xl font-bold">Code Signing</h3>
      </div>
      <p class="text-pretty text-lg">
        Ensure that only you can publish updates to your app. Code signing is a
        crucial security feature to verify the authenticity and integrity of
        your updates.
      </p>
      <!-- Capacitor Config Code -->
      <!-- Capawesome CLI Command -->
      <!-- RSA Key Pair Illustration -->
    </div>
    <!-- Delta Updates -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.file-diff" class="mr-2" />
        <h3 class="text-xl font-bold">Delta Updates</h3>
      </div>
      <p class="text-pretty text-lg">
        Reduce the size of your updates by only sending the changes to your app.
        Delta updates save traffic and reduce the time it takes to download and
        install updates.
      </p>
      <!-- Delta Update Illustration -->
      <!-- File Structure -->
      <!-- Download Illustration -->
    </div>
    <!-- Channel Support -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.layers" class="mr-2" />
        <h3 class="text-xl font-bold">Channel Support</h3>
      </div>
      <p class="text-pretty text-lg">
        Organize your updates by creating different channels for your app.
        Channels allow you to manage different versions of your app and target
        specific groups of users.
      </p>
      <!-- Channel Illustration -->
      <!-- Channel Management UI -->
      <!-- Channel API -->
    </div>
    <!-- Flexible Hosting (Self-hosted bundles) -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.hard-drive" class="mr-2" />
        <h3 class="text-xl font-bold">Flexible Hosting</h3>
      </div>
      <p class="text-pretty text-lg">
        Host your bundles on your own server or use our CDN. Our platform is
        flexible and allows you to choose the hosting solution that fits your
        needs.
      </p>
      <!-- Server/CDN Illustration -->
      <!-- Create Bundle UI from Console -->
    </div>
    <!-- CI/CD Integrations (Capawesome CLI + GitHub Action) -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.workflow" class="mr-2" />
        <h3 class="text-xl font-bold">CI/CD Integrations</h3>
      </div>
      <p class="text-pretty text-lg">
        Automate your deployment process with our CI/CD integrations. Use the
        Capawesome CLI or our GitHub Action to publish updates to your app with
        ease.
      </p>
      <!-- Capawesome CLI Command -->
      <!-- GitHub Action -->
      <!-- CI/CD Illustration -->
    </div>
    <!-- API -->
    <div
      class="flex flex-1 flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.chevrons-left-right-ellipsis" class="mr-2" />
        <h3 class="text-xl font-bold">API</h3>
      </div>
      <p class="text-pretty text-lg">
        Use our API to access your bundles, channels and devices
        programmatically. Perfect for advanced use cases and custom
        integrations.
      </p>
      <!-- API Documentation -->
      <!-- API Console -->
      <!-- API Illustration -->
    </div>
    <!-- Custom Properties -->
    <!-- Multiple Channels -->
  </div>
</section>
